module.exports = [{
      plugin: require('/Users/nicoleatack/plickers-static-site/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-53373915-2"},
    },{
      plugin: require('/Users/nicoleatack/plickers-static-site/node_modules/gatsby-plugin-web-font-loader/gatsby-browser'),
      options: {"plugins":[],"custom":{"families":["Effra:n4,n5,n7,n8"]},"timeout":15000},
    },{
      plugin: require('/Users/nicoleatack/plickers-static-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
